"use client";

import Button from '@/components/button';
import styles from './_hcp-util-nav.module.scss';
import { useContext } from 'react';
import { LayoutContext } from '@/components/layout-context-container';
import CustomImage from '@/components/image';

export default function HcpUtilNav() {
  const { setShowMobileMenu } = useContext(LayoutContext);

  return (
    <>
      <Button
        customClass={styles.pi}
        href="https://www.neurocrine.com/crenessitypi"
        targetBlank
        onClick={() => setShowMobileMenu(false)}
        data-gtm-event-category="Header"
        data-gtm-event-action="Click"
        data-gtm-event-label="Prescribing Information"
      >
        Prescribing Information <CustomImage
          src='/images/icons/icon-external-link.svg'
          width={9}
          height={9}
          className={styles.external_icon}
        />
      </Button>
      <Button
        customClass={styles.patient_site}
        href="https://www.crenessity.com"
        targetBlank
        onClick={() => setShowMobileMenu(false)}
        data-gtm-event-category="Header"
        data-gtm-event-action="Click"
        data-gtm-event-label="Patient Site"
      >
        Patient Site <CustomImage
          src='/images/icons/icon-external-link.svg'
          width={9}
          height={9}
          className={styles.external_icon}
        />
      </Button>
      <Button
        forceAnchorTag
        customClass={styles.stay_connected}
        href="/support-resources#crm-sign-up"
        onClick={() => setShowMobileMenu(false)}
        data-gtm-event-category="Header"
        data-gtm-event-action="Click"
        data-gtm-event-label="Get in Touch"
      >
       Get in Touch
      </Button>
    </>
  );
}